import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';
import { SilobagClosePayload, SilobagImagesResponse } from './silobag-images.types';

export async function silobagImagesService({ query: rawQuery }: SilobagClosePayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.get<SilobagImagesResponse>(ENDPOINT.IMAGES_SILOBAGS, { query });

  return {
    response,
    summary: data,
  };
}
